module.exports = __webpack_public_path__ + "fonts/VetoSansCond-MediumItalic_1.b36ef3c9.woff2";